import React from 'react';
import PropTypes from 'prop-types';

import { composeClassName } from '../../utils/common.js';

import AvatarImage from '../../utils/AvatarImage.jsx';
import withMessage from '../../withMessage.jsx';

const TypingMessage = ({
  text,
  nickname,
  imgParams,
  isLastInGroup,
  isFirstInGroup,
  messageViewType,
}) => (
  <div className={`${composeClassName('operator', isFirstInGroup, isLastInGroup)} typing-message`}>

    { messageViewType === 'bubble' && <AvatarImage {...{ messageViewType, imgParams, nickname }} /> }

    <div className="status">
      {
        messageViewType !== 'bubble'
        && <p className="author">{text}</p>
      }

      <p>
        <span className="circles">
          <span className="circle circle-1" />
          <span className="circle circle-2" />
          <span className="circle circle-3" />
        </span>
      </p>
    </div>
  </div>
);

if (process.env.NODE_ENV !== 'production') {
  TypingMessage.propTypes = {
    nickname: PropTypes.string.isRequired,
    isLastInGroup: PropTypes.bool.isRequired,
    isFirstInGroup: PropTypes.bool.isRequired,
    messageViewType: PropTypes.string.isRequired,
    imgParams: PropTypes.object,
    text: PropTypes.string,
  };
}

export default withMessage(TypingMessage);
